exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".party {\n  position: fixed;\n  z-index: 250;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255,255,255,0.95);\n  display: none;\n}\n.party.transparent-background {\n  background-color: transparent;\n}\n", ""]);

// exports
